import api from '../..'

export const getRoleByUserId = (userId: number) => {
  return api.get(`administration/users/${userId}/roles/`).then(
    ({
      data: {
        data: {
          attributes: { permissions, roleId },
        },
      },
    }: any) => {
      return { permissions, roleId }
    }
  )
}
